<template>
  <div class="add-user">
    <div class="card-guide">
      <div class="card-guide-body">
        <div class="d-flex justify-content-between">
          <span class="search">
          <label>
            <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                  fill="#B3C2CB"
              />
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                  fill="#B3C2CB"
              />
            </svg>
            <input
                type="search"
                class="search-input"
                placeholder="Search FAQs"
                v-model="searchStr"
            /> </label
          ></span>
        </div>

        <div class="faqs" role="tablist">
          <b-card no-body class="mb-1" v-for="(faq, i) in faqs" :key="i">
            <b-card-header
                header-tag="header"
                :class="{ active: activeCollapse == 'faq' + i }"
                role="tab"
            >
              <b-button
                  class="btn-collapse"
                  block
                  variant="collapse"
                  v-b-toggle="'faq' + i"
              >{{ faq.q }}
              </b-button>
              <span class="chevron" v-b-toggle="'faq' + i">
              <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M16.293 9.29297L12 13.586L7.70697 9.29297L6.29297 10.707L12 16.414L17.707 10.707L16.293 9.29297Z"
                    fill="#B3C2CB"
                />
              </svg>
            </span>
            </b-card-header>
            <b-collapse :id="'faq' + i" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>{{ faq.a }}</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Provider_Site_FAQs",
  components: {},
  created() {},
  mounted() {
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (this.activeCollapse == collapseId) {
        this.activeCollapse = -1;
      }
      if (isJustShown) {
        this.activeCollapse = collapseId;
      }
    });
  },
  props: {
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    provider: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  computed: {
    allFaqs(){
      return this.provider && this.provider.faqs && Array.isArray(this.provider.faqs) ?
          this.provider.faqs : [];
    },
    faqs() {
      if (this.searchStr.trim() == "") return this.allFaqs;

      return this.allFaqs.filter(faq => {
        return (
            faq.q.toLowerCase().includes(this.searchStr.toLowerCase().trim()) ||
            faq.a.toLowerCase().includes(this.searchStr.toLowerCase().trim())
        );
      });
    }
  },
  methods: {},
  data() {
    return {
      searchStr: "",
      activeIndex: -1,
      activeCollapse: -1,
      isJustShown: false
    };
  }
};
</script>

<style lang="scss" scoped>
.add-faqs {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-faq {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  input {
    margin-top: 48px;
    margin-bottom: 30px;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-faq {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.faqs {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
}
.counter {
  margin-top: 5px;
  font-size: 12px;
  float: right;
}
</style>
